// import external dependencies
import 'jquery';

// Debug
// import './debug';

// JS for partials
import './partials/app-header';
import './partials/post-list';
// import './partials/back-to-top';
// import './partials/newsletter-signup';
// import './partials/pagination';


const app = (function() {

  //
  //  Initialization / termination
  //
  const init = () => {
    // Remove .no-js class from <html> to remove JS fallback styles
    $('html').removeClass('no-js');
  };

  return {
    init: init,
  };
})();

$(document).ready(function() {
  app.init();
});


// WEBPACK FOOTER //
// ./scripts/main.js